<template>
    <div class="p-registration container">
        <messageController> </messageController>
        <div class="row">
            <div class="col-xs-12">
                <h1 id="registration">{{translate('Registration.text0')}}</h1>
                <pageTitle :title="translate('Registration.text7')"> </pageTitle>
                <div class="well p-registration__well">
                    <div class="form-group">
                        <label >{{translate('Registration.text1')}}</label>
                        <input type="email" v-model="firstName" class="form-control" >
                    </div>
                    <div class="form-group">
                        <label >{{translate('Registration.text2')}}</label>
                        <input type="email" v-model="sureName" class="form-control" >
                    </div>
                    <div class="form-group">
                        <label >{{translate('Registration.text3')}}</label>
                        <input type="email" v-model="email" class="form-control" >
                    </div>
                    <div class="form-group">
                        <label >{{translate('Registration.text4')}}</label>
                        <input type="password" v-model="password" class="form-control" >
                    </div>
                    <div class="form-group">
                        <label >{{translate('Registration.text5')}}</label>
                        <input type="password" v-model="password2" class="form-control" >
                    </div>

                    <div class="btn-wrapper">
                        <button @click="registration()"
                                type="button"
                                class="btn btn-default "
                                >{{translate('Registration.text6')}}</button>
                    </div>

                </div>
            </div>
            <div class="language-bar">
                <span class="glyphicon glyphicon-globe" aria-hidden="true"></span>
                <div :class="{'link-lang': this.$i18n.locale !== 'cz'}" @click="changeLanguage('cz')">Čeština</div>
                |
                <div :class="{'link-lang': this.$i18n.locale !== 'en'}" @click="changeLanguage('en')">English</div>
            </div>
        </div>
    </div>
</template>

<script>
    import pageTitle from "../components/pageTitle";
    import translate from "../mixins/translate";
    import messageController from "../components/messageController";

    export default {
        name: "registration",
        data() {
            return {
                firstName: '',
                sureName: '', // sure :D
                email: '@',
                password: '',
                password2: '',
                langs: ['cz', 'en']
            }
        },
        components: {
            pageTitle,
            messageController
        },
        methods: {
            async registration() {
                if (this.password === this.password2) {
                    try{
                        await this.$store.dispatch('login', {
                            method: 'register',
                            email: this.email,
                            password: this.password,
                            firstname: this.firstName,
                            surname: this.sureName
                        });
                        await this.registrationSuccessful();
                    } catch(e){
                        if(e === 'UserNotInitializedError'){
                            await this.registrationSuccessful();
                        } else if(e === 'DuplicateEmailError'){
                            this.$eventHub.$emit('openMessageController', 'error' , translate('Registration.text9', "An account with this email already exists"));
                        } else {
                            this.$eventHub.$emit('openMessageController', 'error' , translate('Registration.text10', "Registration was not successful"));
                        }
                    }
                } else {
                    this.$eventHub.$emit('openMessageController', 'error' , translate('Registration.text8', "Passwords do not match"));
                }
            },
            async registrationSuccessful(){
                this.$eventHub.$emit('openMessageController', 'success' , translate('Registration.text11', "Registration was successful. Wait for the admin to grant you rights"));
                await setTimeout(
                    () =>  this.$router.push({name: 'Login'}), 3500
                )

            },
            alert(message){
                alert(message);

            },
            changeLanguage(lang) {
                if (this.chosenlang !== lang && this.langs.includes(lang)) {
                    this.$i18n.locale = lang;
                }
            }
        },
        computed: {
            chosenlang() {
                return this.$i18n.locale;
            }
        }

    }
</script>

<style lang="less" scoped>
    .btn-wrapper{
        width: 100%;
        height: 2.5em;
    }
    .btn-wrapper button {
        float: right;
    }
    .p-registration {
        margin-top: 50px;
    h1 {
        text-transform: uppercase;
        font-weight: 600;
    }
    &__well {
         max-width: 400px;
         margin: 0 auto;
     }
    }
    .language-bar {
        display: flex;
        margin: auto;
        white-space: pre;
        padding-top: 1em;
    }
    .glyphicon-globe {
        zoom: 1.3;
        color: #8898aa;
        margin-right: .5em;
    }
    .link-lang {
        cursor: pointer;
        color: #538bbe;
    }
</style>
